var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllocate = function SvgAllocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3,
    cy: 26.4,
    r: 2.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.7c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.2-2.7-2.7-2.7m6.7-12.3c-.8-.4-1.8 0-2.1.8l-3.6 8-.1.2c-.2.8.1 1.6.9 1.9.8.4 1.8 0 2.1-.8l3.6-8 .1-.2c.2-.7-.1-1.5-.9-1.9m5.1 10.4c.9 0 1.6-.6 1.6-1.3v-7.4c-.1-.6-.8-1.1-1.6-1.1-.9 0-1.6.6-1.6 1.3v7.4c.1.6.8 1.1 1.6 1.1m11.2 1.9c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.2-2.7-2.7-2.7m-1.3-1.3c.8-.4 1.2-1.3.8-2.1l-3.6-8c-.4-.8-1.3-1.2-2.1-.8s-1.2 1.3-.8 2.1l3.6 8c.3.8 1.3 1.1 2.1.8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3,
    cy: 6.7,
    r: 3.7
  })));
};
export default SvgAllocate;